
import GiftCertificateIndex from '../components/gift_certificates/GiftCertificateIndex.vue';
import Vue from 'vue';

Vue.component('gift-certificate-index', GiftCertificateIndex);

export default Vue.extend({});
